// extracted by mini-css-extract-plugin
module.exports = {"company-menu-wrapper":"CompanyMenu_company-menu-wrapper___jxHU","active-menu":"CompanyMenu_active-menu__fVL_x"};